// Rounds an axis to clean, human-friendly steps (10s, 20s, 50s, 100s, ...)
// instead of whatever arbitrary decimals the raw data min/max fall on.
export function findNiceAxis(
  min: number,
  max: number,
  tickCount: number,
): { niceMin: number; niceMax: number; ticks: number[] } {
  const range = Math.max(max - min, 1)
  const roughStep = range / (tickCount - 1)
  const exponent = Math.floor(Math.log10(roughStep))

  const candidates: number[] = []
  for (let e = exponent - 2; e <= exponent + 2; e++) {
    for (const fraction of [1, 1.5, 2, 2.5, 3, 4, 5, 6, 7, 8, 9, 10]) {
      candidates.push(fraction * Math.pow(10, e))
    }
  }
  candidates.sort((a, b) => a - b)

  for (const step of candidates) {
    const niceMin = Math.max(0, Math.floor(min / step) * step)
    const niceMax = niceMin + step * (tickCount - 1)
    if (niceMax >= max) {
      const ticks = Array.from(
        { length: tickCount },
        (_, index) => Math.round((niceMin + step * index) * 1e6) / 1e6,
      )
      return { niceMin, niceMax, ticks }
    }
  }

  return { niceMin: 0, niceMax: max, ticks: [max] }
}
